import { IRegulation } from '../contracts/amendment.contract';
import { ICriteria } from '../contracts/criteria.contract';
import AxiosService from './axios.service';
import ConfigService from './config.service';

const getByCriteria = async (criteria: ICriteria, controller: AbortController): Promise<IRegulation[] | undefined> => {
    const res = await AxiosService.getInstance.post(`${ConfigService.appConfig.baseApiUrl}/Amendment/FilterCriteria`, { ...criteria }, { signal: controller.signal });
    return res.data;
};

const getByVesselClassNumbers = async (classNumbers: string[], controller: AbortController): Promise<IRegulation[] | undefined> => {
    const res = await AxiosService.getInstance.post(`${ConfigService.appConfig.baseApiUrl}/Amendment/GetByClassNumbers`, { vesselClassNumbers: [...classNumbers] }, { signal: controller.signal });
    return res.data;
};

const RegulationService = {
    getByCriteria,
    getByVesselClassNumbers
};

export default RegulationService;
